<template>
  <b-modal
    v-model="modalShow"
    size="xl"
    scrollable
    title="Invoice Details"
    @hidden="$emit('modal-closed')"
  >
    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        label="Small Spinner"
        variant="primary"
      />
    </div>

    <b-alert
      variant="danger"
      :show="loadingError ? true : false"
    >
      <div class="alert-body">
        <p>
          {{ loadingError }}
        </p>
      </div>
    </b-alert>

    <div v-if="!loading && !loadingError">
      <invoice-info
        :item="invoiceItem"
      />
      <b-row
        v-if="openTickets && openTickets.length > 0"
        class="mb-2"
      >
        <b-col class="d-flex align-items-start">
          <span
            class="text-danger font-weight-bold mr-2"
            style="flex-shrink: 0;"
          >Open Tickets :&nbsp;</span>
          <div style="overflow-y: auto; max-height: 100px; flex: 1; line-height: 1.8;">
            <span
              v-for="(ticket, index) in openTickets"
              :key="ticket.id"
              class="text-primary font-weight-bold"
              style="cursor: pointer; display: inline-block;"
              @click="openTicketId = ticket.id"
            >
              {{ ticket.ticket_id }}<span v-if="index < openTickets.length - 1">,&nbsp;</span>
            </span>
          </div>
        </b-col>
      </b-row>
    </div>

    <ticket-details
      v-if="openTicketId"
      :ticket-id="openTicketId"
      @modal-closed="openTicketId=null"
      @onDiscrepancyClose="fetchTicketDetails"
      @onCloseDialog="fetchTicketDetails"
    />

    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="secondary"
          class="float-right"
          @click="modalShow=false"
        >
          Close
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BButton, BAlert, BSpinner, BRow, BCol,
} from 'bootstrap-vue'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import TicketDetails from '@/components/Tickets/SupplierTickets/TicketDetails.vue'
import InvoiceInfo from './InvoiceInfo.vue'

export default {
  components: {
    BButton,
    BAlert,
    BSpinner,
    BRow,
    BCol,
    InvoiceInfo,
    TicketDetails,
  },
  props: {
    invoiceId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      invoiceItem: null,
      modalShow: true,
      loadingError: null,
      loading: true,
      openTickets: null,
      openTicketId: null,
    }
  },
  created() {
    this.fetchDetails()
  },
  methods: {
    async fetchDetails() {
      try {
        // First fetch invoice data
        const invoiceResponse = await axios.get(`/invoices/invoice/${this.invoiceId}/`)
        this.invoiceItem = invoiceResponse.data

        // Then fetch ticket details based on invoice number
        if (this.invoiceItem.invoice_no) {
          await this.fetchTicketDetails()
        }

        this.loadingError = null
        this.loading = false
      } catch (error) {
        this.loadingError = error?.response?.data?.detail || 'Error fetching invoice details'
        this.loading = false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.loadingError,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    async fetchTicketDetails() {
      if (!this.invoiceItem || !this.invoiceItem.invoice_no) {
        return
      }

      try {
        const response = await axios.post('/tickets/filtered_supplier_tickets', {
          filters: {
            invoice_no: this.invoiceItem.invoice_no,
            status: ['Open', 'In Progress'],
          },
        })

        if (response.data.results.length > 0) {
          this.openTickets = response.data.results.map(ticket => ({
            id: ticket.id,
            ticket_id: ticket.ticket_id,
          }))
        } else {
          this.openTickets = []
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.response?.data?.detail || 'Error fetching tickets',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>
